import { gsap } from "gsap";

import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { GetBy } from '../_app/cuchillo/core/Element';

class ScrollItem__Footer extends VScroll_Item {
  logo;

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this.logo = GetBy.class('icon', __link)[0];

    this.onShow = () => {
      gsap.killTweensOf(this.logo);
      gsap.set(this.logo, { opacity: 0 });
      gsap.set(this.logo, { opacity: 1, delay: .1 });
      gsap.set(this.logo, { opacity: 0, delay: .2 });
      gsap.set(this.logo, { opacity: 1, delay: .3 });
    };
  }
}

Scroll._registerClass('Footer', ScrollItem__Footer);
